import * as React from 'react';

import {Label} from '../../form/label';

import styles from './slack-message-preview.module.css';

type Props = {
    previewMessage: React.ReactNode;
    previewContent: React.ReactNode;
};

export function SlackMessagePreview(props: Props) {
    return (
        <div className={styles['preview-wrapper']}>
            <Label htmlFor='messagePreview'>Preview</Label>
            <div className={styles['preview-card']}>
                <img className={styles['preview-card-logo']} />
                <div className={styles['preview-card-content']}>
                    <div className={styles['preview-card-header']}>
                        <h3>Nutshell</h3>
                        {props.previewMessage}
                    </div>
                    {props.previewContent}
                </div>
            </div>
        </div>
    );
}
